// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pickem-card {
  width: 309.145px;
  height: 101.934px;
  flex-shrink: 0;
  border-radius: var(--1, 8px) var(--1, 8px) var(--1, 8px) var(--1, 8px);
  border: 0.5px solid #D6D2D2;
  background: #FFF;
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  margin-bottom: 16px;
  box-shadow: 0px 1px 3px 0 rgba(0, 0, 0, 0.3);
}

.pickem-card-desktop {
  width: 375px;
  height: 130px;
  flex-shrink: 0;
  border-radius: var(--1, 8px) var(--1, 8px) var(--1, 8px) var(--1, 8px);
  border: 0.5px solid #D6D2D2;
  background: #FFF;
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  margin-bottom: 16px;
  box-shadow: 0px 1px 3px 0 rgba(0, 0, 0, 0.3);
}

.top-border {
  display: flex;
  width: 309.145px;
  height: 25.4px;
  padding: var(--1, 14px);
  justify-content: space-between;
  align-items: center;
  gap: var(--borderRadius, 4px);
  flex-shrink: 0;
  border-radius: 8px 8px var(--none, 0px) var(--none, 0px);
  background: #E5E5E5;
}

.top-border-desktop {
  display: flex;
  width: 375px;
  height: 31px;
  padding: var(--1, 14px);
  justify-content: space-between;
  align-items: center;
  gap: var(--borderRadius, 4px);
  flex-shrink: 0;
  border-radius: 8px 8px var(--none, 0px) var(--none, 0px);
  background: #E5E5E5;
}

.top-left-text {
  display: flex;
  width: 167px;
  height: 6px;
  flex-direction: column;
  justify-content: center;
  flex-shrink: 0;
  color: #232425;
  font-family: Inter;
  font-size: 10px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  text-align: left;
}

.top-left-text-desktop {
  display: flex;
  width: auto;
  height: 15px;
  flex-direction: column;
  justify-content: center;
  flex-shrink: 0;
  color: #232425;
  font-family: Inter;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  text-align: left;
}

.top-right-text {
  display: flex;
  width: 76px;
  height: 6px;
  flex-direction: column;
  justify-content: center;
  flex-shrink: 0;
  color: #232425;
  text-align: right;
  font-family: Inter;
  font-size: 10px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  text-transform: uppercase; /* This will make the text all caps */
}

.top-right-text-desktop {
  display: flex;
  width: 95px;
  height: 15px;
  flex-direction: column;
  justify-content: center;
  flex-shrink: 0;
  color: #232425;
  text-align: right;
  font-family: Inter;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  text-transform: uppercase; /* This will make the text all caps */
}

.bottom-border {
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  gap: var(--borderRadius, 4px);
  flex-shrink: 0;
  border-top: 1px solid #D6D2D2;
  border-radius: var(--none, 0px) var(--none, 0px) var(--1, 8px) var(--1, 8px);
  background: #FFF;
  padding: 0 13px;
}

.bottom-border-desktop {
  display: flex;
  width: 100%;
  height: 25.4px;
  justify-content: space-between;
  align-items: center;
  gap: var(--borderRadius, 4px);
  flex-shrink: 0;
  border-top: 1px solid #D6D2D2;
  border-radius: var(--none, 0px) var(--none, 0px) var(--1, 8px) var(--1, 8px);
  background: #FFF;
  padding: 0 16px;
}

.bottom-left-text {
  display: flex;
  width: 125px;
  height: 18px;
  flex-direction: column;
  justify-content: center;
  text-align: left;
  flex-shrink: 0;
  color: var(--grey-600, #757575);
  font-family: Inter;
  font-size: 8px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}

.bottom-left-text-desktop {
  display: flex;
  width: auto;
  height: 18px;
  margin-top: 6px;
  flex-direction: column;
  justify-content: center;
  text-align: left;
  flex-shrink: 0;
  color: var(--grey-600, #757575);
  font-family: Inter;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}

.bottom-right-text {
  display: flex;
  width: 125px;
  height: 18px;
  flex-direction: column;
  justify-content: center;
  flex-shrink: 0;
  color: var(--grey-600, #757575);
  font-family: Inter;
  font-size: 8px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  text-align: right;
}

.bottom-right-text-desktop {
  display: flex;
  width: 175px;
  height: 18px;
  margin-top: 6px;
  flex-direction: column;
  justify-content: center;
  flex-shrink: 0;
  color: var(--grey-600, #757575);
  font-family: Inter;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  text-align: right;
}

.team-row {
  width: 100%;
  max-width: 288px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 4px;
  margin-bottom: 3px;
}

.team-row-desktop {
  width: 100%;
  max-width: 350px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 4px;
  margin-bottom: 3px;
}

.logo img {
  width: 28px;
  display: block;
  object-fit: contain;
}

.logo-desktop img {
  width: 24px;
  display: block;
  object-fit: contain;
}

.lock-icon {
  width: 16px;
  height: 16px;
  display: block;
  margin: 0 auto;
}

.lock-icon-desktop {
  width: 20px;
  height: 20px;
  display: block;
  margin: 0 auto;
}

.name-and-record {
  color: #002129;
  text-align: left;
  font-family: Inter;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  margin-left: 15px;
  width: 250px;
}

.name-and-record-desktop {
  color: #002129;
  text-align: left;
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  margin-left: 15px;
  width: 250px;
}

.score {
  display: flex;
  width: 42px !important;
  height: var(--score-height, 8px);
  flex-direction: column;
  justify-content: center;
  flex-shrink: 0;
  color: #000;
  text-align: center;
  font-family: Inter;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.score-desktop {
  display: flex;
  width: 42px !important;
  height: var(--score-height, 8px);
  flex-direction: column;
  justify-content: center;
  flex-shrink: 0;
  color: #000;
  text-align: center;
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.pick-button {
  width: 53px;
  height: 21px;
  flex-shrink: 0;
  border-radius: var(--border-radius, 4px);
  background: #E5E5E5;
  display: flex;
  justify-content: center;
  align-items: center;
}

.pick-button-desktop {
  width: 68px;
  height: 27px;
  flex-shrink: 0;
  border-radius: var(--border-radius, 4px);
  background: #E5E5E5;
  display: flex;
  justify-content: center;
  align-items: center;
}

.empty-button {
  width: 53px;
  height: 21px;
  flex-shrink: 0;
  border-radius: var(--border-radius, 4px);
  background: #FFF;
  display: flex;
  justify-content: center;
  align-items: center;
}

.empty-button-desktop {
  width: 68px;
  height: 27px;
  flex-shrink: 0;
  border-radius: var(--border-radius, 4px);
  background: #FFF;
  display: flex;
  justify-content: center;
  align-items: center;
}

.pick-button.clicked {
  border-radius: var(--borderRadius, 4px);
  border: 1px solid #00aad1;
  background: #d8f8ff;
}

.pick-button-desktop.clicked {
  border-radius: var(--borderRadius, 4px);
  border: 1px solid #00aad1;
  background: #d8f8ff;
}

.pick-button.clicked-pending {
  border-radius: var(--borderRadius, 4px);
  border: 1px solid #00aad1;
  background: #00aad1;
}

.pick-button-desktop.clicked-pending {
  border-radius: var(--borderRadius, 4px);
  border: 1px solid #00aad1;
  background: #00aad1;
}

.pick-button-text {
  width: 50px;
  color: #002129;
  text-align: center;
  font-family: Inter;
  font-size: 11px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}

.pick-button-text-desktop {
  width: 50px;
  color: #002129;
  text-align: center;
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}

.pick-button-text.saved {
  width: 33px;
  color: #FFF;
  text-align: center;
  font-family: Inter;
  font-size: 11px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}

.pick-button-text-desktop.saved {
  width: 38px;
  color: #FFF;
  text-align: center;
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}

.submit-button {
  display: flex;
  width: 185px;
  height: 48px;
  padding: 8px 22px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  border-radius: 4px;
  background: rgba(0, 0, 0, 0.21) !important;
  box-shadow: 0px 1px 5px 0px rgba(0, 0, 0, 0.12), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 3px 1px -2px rgba(0, 0, 0, 0.2);
  cursor: default;
  color: #FFF !important;
  font-feature-settings: "clig" off, "liga" off;
  font-family: Inter;
  font-size: 20px !important;
  font-style: normal;
  font-weight: 700;
  line-height: 26px; /* 130% */
  letter-spacing: 0.46px;
  text-transform: capitalize;
  margin: 0 auto;
  margin-bottom: 32px !important;
}

.submit-button.active {
  background: #00AAD1 !important;
  color: #fff !important;
  font-size: 20px !important;
  cursor: pointer;
}

/* Default styles for larger screens */
.user-submit-bar {
  width: 100%;
  background: #FFF; /* Updated background */
  border-radius: var(--1, 8px) var(--1, 8px) var(--none, 0px) var(--none, 0px); /* Updated border radius */
  box-shadow: 0 -2px 4px rgba(0, 0, 0, 0.25);
  position: fixed !important; /* Fix to the bottom of the screen */
  bottom: 0 !important;
  z-index: 1000 !important;
  top: auto; /* Ensure no top positioning */
  bottom: auto; /* Ensure no bottom positioning */
  left: auto; /* Ensure no left positioning */
  right: auto; /* Ensure no right positioning */
}

/* Styles for mobile devices */
@media (min-width: 767px) {
  .user-submit-bar {
    border-radius: 0;
    box-shadow: none;
    border-top: 4px solid #000;
  }
}
.week-select {
  color: white;
  background-color: transparent;
  border: none;
  font-size: 24px;
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: center;
}
.week-select .MuiSelect-select {
  padding: 0;
}
.week-select .MuiOutlinedInput-notchedOutline {
  border: none;
}
.week-select .MuiSvgIcon-root {
  color: white;
}`, "",{"version":3,"sources":["webpack://./src/components/NFLPickEm/NFLPickEmStyles/PickEmStyles.scss"],"names":[],"mappings":"AAAA;EACI,gBAAA;EACA,iBAAA;EACA,cAAA;EACA,sEAAA;EACA,2BAAA;EAEA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,cAAA;EACA,mBAAA;EACA,4CAAA;AAAJ;;AAGA;EACI,YAAA;EACA,aAAA;EACA,cAAA;EACA,sEAAA;EACA,2BAAA;EAEA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,cAAA;EACA,mBAAA;EACA,4CAAA;AADJ;;AAIA;EACI,aAAA;EACA,gBAAA;EACA,cAAA;EACA,uBAAA;EACA,8BAAA;EACA,mBAAA;EACA,6BAAA;EACA,cAAA;EACA,wDAAA;EAIA,mBAAA;AAJJ;;AAOA;EACI,aAAA;EACA,YAAA;EACA,YAAA;EACA,uBAAA;EACA,8BAAA;EACA,mBAAA;EACA,6BAAA;EACA,cAAA;EACA,wDAAA;EAIA,mBAAA;AAPJ;;AAWA;EACI,aAAA;EACA,YAAA;EACA,WAAA;EACA,sBAAA;EACA,uBAAA;EACA,cAAA;EACA,cAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;AARJ;;AAWA;EACI,aAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;EACA,uBAAA;EACA,cAAA;EACA,cAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;AARJ;;AAaA;EACI,aAAA;EACA,WAAA;EACA,WAAA;EACA,sBAAA;EACA,uBAAA;EACA,cAAA;EACA,cAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,yBAAA,EAAA,qCAAA;AAVJ;;AAaA;EACI,aAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;EACA,uBAAA;EACA,cAAA;EACA,cAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,yBAAA,EAAA,qCAAA;AAVJ;;AAgBA;EACI,aAAA;EACA,WAAA;EAGA,8BAAA;EACA,mBAAA;EACA,6BAAA;EACA,cAAA;EACA,6BAAA;EACA,4EAAA;EAIA,gBAAA;EACA,eAAA;AAlBJ;;AAqBA;EACI,aAAA;EACA,WAAA;EACA,cAAA;EAEA,8BAAA;EACA,mBAAA;EACA,6BAAA;EACA,cAAA;EACA,6BAAA;EACA,4EAAA;EAIA,gBAAA;EACA,eAAA;AAtBJ;;AAyBA;EACI,aAAA;EACA,YAAA;EACA,YAAA;EACA,sBAAA;EACA,uBAAA;EACA,gBAAA;EACA,cAAA;EACA,+BAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAtBJ;;AAyBA;EACI,aAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,sBAAA;EACA,uBAAA;EACA,gBAAA;EACA,cAAA;EACA,+BAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAtBJ;;AA0BA;EACI,aAAA;EACA,YAAA;EACA,YAAA;EACA,sBAAA;EACA,uBAAA;EAEA,cAAA;EACA,+BAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,iBAAA;AAvBJ;;AA0BA;EACI,aAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;EACA,sBAAA;EACA,uBAAA;EAEA,cAAA;EACA,+BAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,iBAAA;AAvBJ;;AA6BA;EACI,WAAA;EAEA,gBAAA;EACA,cAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;AA3BJ;;AA8BA;EACI,WAAA;EAEA,gBAAA;EACA,cAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;AA5BJ;;AA+BA;EACI,WAAA;EACA,cAAA;EACA,mBAAA;AA5BJ;;AA+BA;EACI,WAAA;EACA,cAAA;EACA,mBAAA;AA5BJ;;AA+BA;EACI,WAAA;EACA,YAAA;EACA,cAAA;EACA,cAAA;AA5BJ;;AA+BA;EACI,WAAA;EACA,YAAA;EACA,cAAA;EACA,cAAA;AA5BJ;;AAgCA;EAEI,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,iBAAA;EACA,YAAA;AA9BJ;;AAkCA;EAEI,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,iBAAA;EACA,YAAA;AAhCJ;;AAsCA;EACI,aAAA;EACA,sBAAA;EACA,gCAAA;EACA,sBAAA;EACA,uBAAA;EACA,cAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAnCJ;;AAsCA;EACI,aAAA;EACA,sBAAA;EACA,gCAAA;EACA,sBAAA;EACA,uBAAA;EACA,cAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAnCJ;;AAsCA;EACI,WAAA;EACA,YAAA;EACA,cAAA;EACA,wCAAA;EACA,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAnCJ;;AAsCA;EACI,WAAA;EACA,YAAA;EACA,cAAA;EACA,wCAAA;EACA,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAnCJ;;AAsCA;EACI,WAAA;EACA,YAAA;EACA,cAAA;EACA,wCAAA;EACA,gBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAnCJ;;AAuCA;EACI,WAAA;EACA,YAAA;EACA,cAAA;EACA,wCAAA;EACA,gBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AApCJ;;AAwCA;EACI,uCAAA;EACA,yBAAA;EACA,mBAAA;AArCJ;;AAwCE;EACE,uCAAA;EACA,yBAAA;EACA,mBAAA;AArCJ;;AAwCA;EACI,uCAAA;EACA,yBAAA;EACA,mBAAA;AArCJ;;AAwCE;EACE,uCAAA;EACA,yBAAA;EACA,mBAAA;AArCJ;;AAyCA;EACI,WAAA;EACA,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAtCJ;;AAyCA;EACI,WAAA;EACA,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAtCJ;;AAyCA;EACI,WAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAtCJ;;AAyCA;EACI,WAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAtCJ;;AAyCA;EACI,aAAA;EACA,YAAA;EACA,YAAA;EACA,iBAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,cAAA;EACA,kBAAA;EACA,0CAAA;EACA,yHAAA;EACA,eAAA;EACA,sBAAA;EACA,6CAAA;EACA,kBAAA;EACA,0BAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,SAAA;EACA,sBAAA;EACA,0BAAA;EACA,cAAA;EACA,8BAAA;AAtCJ;;AAwCE;EACE,8BAAA;EACA,sBAAA;EACA,0BAAA;EACA,eAAA;AArCJ;;AAwCE,sCAAA;AACF;EACI,WAAA;EAEA,gBAAA,EAAA,uBAAA;EACA,4EAAA,EAAA,0BAAA;EACA,0CAAA;EACA,0BAAA,EAAA,oCAAA;EACI,oBAAA;EACA,wBAAA;EACJ,SAAA,EAAA,8BAAA;EACA,YAAA,EAAA,iCAAA;EACA,UAAA,EAAA,+BAAA;EACA,WAAA,EAAA,gCAAA;AAtCJ;;AAyCA,8BAAA;AACA;EACI;IACI,gBAAA;IACA,gBAAA;IACA,0BAAA;EAtCN;AACF;AA+CE;EACE,YAAA;EACA,6BAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AA7CJ;AA+CI;EACI,UAAA;AA7CR;AAgDI;EACI,YAAA;AA9CR;AAiDI;EACI,YAAA;AA/CR","sourcesContent":[".pickem-card {\n    width: 309.145px;\n    height: 101.934px;\n    flex-shrink: 0;\n    border-radius: var(--1, 8px) var(--1, 8px)  var(--1, 8px) var(--1, 8px);\n    border: 0.5px solid #D6D2D2;\n    // border-left: 0.5px solid #D6D2D2;\n    background: #FFF;\n    display: flex;\n    flex-direction: column;\n    margin: 0 auto;\n    margin-bottom: 16px;\n    box-shadow: 0px 1px 3px 0 rgba(0, 0, 0, 0.3);\n}\n\n.pickem-card-desktop {\n    width: 375px;\n    height: 130px;\n    flex-shrink: 0;\n    border-radius: var(--1, 8px) var(--1, 8px)  var(--1, 8px) var(--1, 8px);\n    border: 0.5px solid #D6D2D2;\n    // border-left: 0.5px solid #D6D2D2;\n    background: #FFF;\n    display: flex;\n    flex-direction: column;\n    margin: 0 auto;\n    margin-bottom: 16px;\n    box-shadow: 0px 1px 3px 0 rgba(0, 0, 0, 0.3);\n}\n\n.top-border {\n    display: flex;\n    width: 309.145px;\n    height: 25.4px;\n    padding: var(--1, 14px);\n    justify-content: space-between;\n    align-items: center;\n    gap: var(--borderRadius, 4px);\n    flex-shrink: 0;\n    border-radius:  8px 8px var(--none, 0px) var(--none, 0px);\n    // border-right: 0.5px solid #D6D2D2;\n    // border-bottom: 0.5px solid #D6D2D2;\n    // border-left: 0.5px solid #D6D2D2;\n    background: #E5E5E5;\n}\n\n.top-border-desktop {\n    display: flex;\n    width: 375px;\n    height: 31px;\n    padding: var(--1, 14px);\n    justify-content: space-between;\n    align-items: center;\n    gap: var(--borderRadius, 4px);\n    flex-shrink: 0;\n    border-radius:  8px 8px var(--none, 0px) var(--none, 0px);\n    // border-right: 0.5px solid #D6D2D2;\n    // border-bottom: 0.5px solid #D6D2D2;\n    // border-left: 0.5px solid #D6D2D2;\n    background: #E5E5E5;\n}\n\n\n.top-left-text {\n    display: flex;\n    width: 167px;\n    height: 6px;\n    flex-direction: column;\n    justify-content: center;\n    flex-shrink: 0;\n    color: #232425;\n    font-family: Inter;\n    font-size: 10px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: normal;\n    text-align: left;\n}\n\n.top-left-text-desktop {\n    display: flex;\n    width: auto;\n    height: 15px;\n    flex-direction: column;\n    justify-content: center;\n    flex-shrink: 0;\n    color: #232425;\n    font-family: Inter;\n    font-size: 12px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: normal;\n    text-align: left;\n}\n\n\n\n.top-right-text {\n    display: flex;\n    width: 76px;\n    height: 6px;\n    flex-direction: column;\n    justify-content: center;\n    flex-shrink: 0;\n    color: #232425;\n    text-align: right;\n    font-family: Inter;\n    font-size: 10px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: normal;\n    text-transform: uppercase; /* This will make the text all caps */\n}\n\n.top-right-text-desktop {\n    display: flex;\n    width: 95px;\n    height: 15px;\n    flex-direction: column;\n    justify-content: center;\n    flex-shrink: 0;\n    color: #232425;\n    text-align: right;\n    font-family: Inter;\n    font-size: 12px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: normal;\n    text-transform: uppercase; /* This will make the text all caps */\n}\n\n\n\n\n.bottom-border {\n    display: flex;\n    width: 100%;\n    // height: 25.4px;\n    // padding: var(--1, 8px);\n    justify-content: space-between;\n    align-items: center;\n    gap: var(--borderRadius, 4px);\n    flex-shrink: 0;\n    border-top: 1px solid #D6D2D2;\n    border-radius: var(--none, 0px) var(--none, 0px) var(--1, 8px) var(--1, 8px);\n    // border-right: 0.5px solid #D6D2D2;\n    // border-bottom: 0.5px solid #D6D2D2;\n    // border-left: 0.5px solid #D6D2D2;\n    background: #FFF;\n    padding: 0 13px;\n}\n\n.bottom-border-desktop {\n    display: flex;\n    width: 100%;\n    height: 25.4px;\n    // padding: var(--1, 8px);\n    justify-content: space-between;\n    align-items: center;\n    gap: var(--borderRadius, 4px);\n    flex-shrink: 0;\n    border-top: 1px solid #D6D2D2;\n    border-radius: var(--none, 0px) var(--none, 0px) var(--1, 8px) var(--1, 8px);\n    // border-right: 0.5px solid #D6D2D2;\n    // border-bottom: 0.5px solid #D6D2D2;\n    // border-left: 0.5px solid #D6D2D2;\n    background: #FFF;\n    padding: 0 16px;\n}\n\n.bottom-left-text {\n    display: flex;\n    width: 125px;\n    height: 18px;\n    flex-direction: column;\n    justify-content: center;\n    text-align: left;\n    flex-shrink: 0;\n    color: var(--grey-600, #757575);\n    font-family: Inter;\n    font-size: 8px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: normal;\n}\n\n.bottom-left-text-desktop {\n    display: flex;\n    width: auto;\n    height: 18px;\n    margin-top: 6px;\n    flex-direction: column;\n    justify-content: center;\n    text-align: left;\n    flex-shrink: 0;\n    color: var(--grey-600, #757575);\n    font-family: Inter;\n    font-size: 12px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: normal;\n}\n\n\n.bottom-right-text {\n    display: flex;\n    width: 125px;\n    height: 18px;\n    flex-direction: column;\n    justify-content: center;\n    text-align: right;\n    flex-shrink: 0;\n    color: var(--grey-600, #757575);\n    font-family: Inter;\n    font-size: 8px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: normal;\n    text-align: right;\n}\n\n.bottom-right-text-desktop {\n    display: flex;\n    width: 175px;\n    height: 18px;\n    margin-top: 6px;\n    flex-direction: column;\n    justify-content: center;\n    text-align: right;\n    flex-shrink: 0;\n    color: var(--grey-600, #757575);\n    font-family: Inter;\n    font-size: 12px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: normal;\n    text-align: right;\n}\n\n\n\n\n.team-row {\n    width: 100%;\n    // height: 50%;\n    max-width: 288px;\n    margin: 0 auto;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-top: 4px;\n    margin-bottom: 3px;\n}\n\n.team-row-desktop {\n    width: 100%;\n    // height: 50%;\n    max-width: 350px;\n    margin: 0 auto;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-top: 4px;\n    margin-bottom: 3px;\n}\n\n.logo img {\n    width: 28px;\n    display: block;\n    object-fit: contain;\n}\n\n.logo-desktop img {\n    width: 24px;\n    display: block;\n    object-fit: contain;\n}\n\n.lock-icon {\n    width: 16px;\n    height: 16px;\n    display: block;\n    margin: 0 auto;\n}\n\n.lock-icon-desktop {\n    width: 20px;\n    height: 20px;\n    display: block;\n    margin: 0 auto;\n}\n\n\n.name-and-record {\n\n    color: #002129;\n    text-align: left;\n    font-family: Inter;\n    font-size: 12px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: normal;\n    margin-left: 15px;\n    width: 250px;\n\n}\n\n.name-and-record-desktop {\n\n    color: #002129;\n    text-align: left;\n    font-family: Inter;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: normal;\n    margin-left: 15px;\n    width: 250px;\n\n}\n\n\n\n.score {\n    display: flex;\n    width: 42px !important;\n    height: var(--score-height, 8px);\n    flex-direction: column;\n    justify-content: center;\n    flex-shrink: 0;\n    color: #000;\n    text-align: center;\n    font-family: Inter;\n    font-size: 12px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: normal;\n}\n\n.score-desktop {\n    display: flex;\n    width: 42px !important;\n    height: var(--score-height, 8px);\n    flex-direction: column;\n    justify-content: center;\n    flex-shrink: 0;\n    color: #000;\n    text-align: center;\n    font-family: Inter;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: normal;\n}\n\n.pick-button {\n    width: 53px;\n    height: 21px;\n    flex-shrink: 0;\n    border-radius: var(--border-radius, 4px);\n    background: #E5E5E5;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.pick-button-desktop {\n    width: 68px;\n    height: 27px;\n    flex-shrink: 0;\n    border-radius: var(--border-radius, 4px);\n    background: #E5E5E5;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.empty-button {\n    width: 53px;\n    height: 21px;\n    flex-shrink: 0;\n    border-radius: var(--border-radius, 4px);\n    background: #FFF;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n\n}\n\n.empty-button-desktop {\n    width: 68px;\n    height: 27px;\n    flex-shrink: 0;\n    border-radius: var(--border-radius, 4px);\n    background: #FFF;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n\n}\n\n.pick-button.clicked {\n    border-radius: var(--borderRadius, 4px);\n    border: 1px solid #00aad1;\n    background: #d8f8ff;\n  }\n\n  .pick-button-desktop.clicked {\n    border-radius: var(--borderRadius, 4px);\n    border: 1px solid #00aad1;\n    background: #d8f8ff;\n  }\n\n.pick-button.clicked-pending {\n    border-radius: var(--borderRadius, 4px);\n    border: 1px solid #00aad1;\n    background: #00aad1;\n  }\n\n  .pick-button-desktop.clicked-pending {\n    border-radius: var(--borderRadius, 4px);\n    border: 1px solid #00aad1;\n    background: #00aad1;\n  }\n\n\n.pick-button-text {\n    width: 50px;\n    color: #002129;\n    text-align: center;\n    font-family: Inter;\n    font-size: 11px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: normal;\n}\n\n.pick-button-text-desktop {\n    width: 50px;\n    color: #002129;\n    text-align: center;\n    font-family: Inter;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: normal;\n}\n\n.pick-button-text.saved {\n    width: 33px;\n    color: #FFF;\n    text-align: center;\n    font-family: Inter;\n    font-size: 11px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: normal;\n}\n\n.pick-button-text-desktop.saved {\n    width: 38px;\n    color: #FFF;\n    text-align: center;\n    font-family: Inter;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: normal;\n}\n\n.submit-button {\n    display: flex;\n    width: 185px;\n    height: 48px;\n    padding: 8px 22px;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    flex-shrink: 0;\n    border-radius: 4px;\n    background: rgba(0, 0, 0, 0.21)  !important;\n    box-shadow: 0px 1px 5px 0px rgba(0, 0, 0, 0.12), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 3px 1px -2px rgba(0, 0, 0, 0.20);\n    cursor: default;\n    color:  #FFF  !important;\n    font-feature-settings: 'clig' off, 'liga' off;\n    font-family: Inter;\n    font-size: 20px !important;\n    font-style: normal;\n    font-weight: 700;\n    line-height: 26px ; /* 130% */\n    letter-spacing: 0.46px;\n    text-transform: capitalize;\n    margin: 0 auto;\n    margin-bottom: 32px !important;\n  }\n  .submit-button.active {\n    background: #00AAD1 !important;\n    color:#fff  !important;\n    font-size: 20px !important;\n    cursor: pointer;\n  }\n\n  /* Default styles for larger screens */\n.user-submit-bar {\n    width: 100%;\n    // border-top-color: #000 !important;\n    background: #FFF; /* Updated background */\n    border-radius: var(--1, 8px) var(--1, 8px) var(--none, 0px) var(--none, 0px); /* Updated border radius */\n    box-shadow: 0 -2px 4px rgba(0, 0, 0, 0.25);\n    position: fixed !important; /* Fix to the bottom of the screen */\n        bottom: 0 !important;\n        z-index: 1000 !important;\n    top: auto; /* Ensure no top positioning */\n    bottom: auto; /* Ensure no bottom positioning */\n    left: auto; /* Ensure no left positioning */\n    right: auto; /* Ensure no right positioning */\n}\n\n/* Styles for mobile devices */\n@media (min-width: 767px) {\n    .user-submit-bar {\n        border-radius: 0;\n        box-shadow: none;\n        border-top: 4px solid #000;\n    }\n}\n\n\n\n\n\n\n\n  .week-select {\n    color: white;\n    background-color: transparent;\n    border: none;\n    font-size: 24px;\n    font-weight: 500;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n    .MuiSelect-select {\n        padding: 0;\n    }\n\n    .MuiOutlinedInput-notchedOutline {\n        border: none;\n    }\n\n    .MuiSvgIcon-root {\n        color: white;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
